<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">账户</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">操作日志</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">操作日志</div>
      </div>
      <div class="panel-body clearfix">
        <div class="ub-box z-margin-bottom-20-precent">
          <div class="zj-select">
            <el-input placeholder="类型/内容" v-model="search" class="input-with-select" @keyup.enter.native="SearchOplog">
              <el-button slot="append" icon="el-icon-search" @click="SearchOplog"></el-button>
            </el-input>
          </div>
        </div>
        <!--列表-->
        <el-table :data="oplogList" highlight-current-row show-header v-loading="listLoading" style="width: 100%;">
          <el-table-column prop="log_type" label="类型" align="center">
          </el-table-column>
          <el-table-column prop="log_content" label="日志内容" min-width="200" align="center">
          </el-table-column>
          <el-table-column prop="log_ip" label="操作ip" align="center">
            <template slot-scope="scope">
              {{scope.row.log_ip}}（{{scope.row.ip_addr}}）
            </template>
          </el-table-column>
          <el-table-column prop="log_time" label="操作时间" align="center">
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import userService from 'business/userService.js'
  export default {
    data() {
      return {
        listLoading:false,
        oplogList: [],
        search:'',
        count:10,
        total:0,
        page:1,
      }
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.SearchOplog()
    },
    methods:{
      async SearchOplog() {
        this.listLoading = true
        let data = 'cmd=user_log'+'&keyword='+ this.search +'&count='+ this.count +'&page='+ this.page
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.msg.allcount
          this.oplogList = vueData.msg.content
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchOplog()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchOplog()
      },
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
</style>



// WEBPACK FOOTER //
// src/pages/user/oplog.vue